import React from 'react';
interface BadgeSwitcherProps {
  isSold?: boolean;
  isExpired?: boolean;
  createdDate: string;
  status: 'published' | 'rejected' | 'pending';
}
const BadgeSwitcher = ({
  createdDate,
  isExpired,
  isSold,
  status,
}: BadgeSwitcherProps) => {
  let badgeClassName = '';
  let badgeText = '';
  switch (true) {
    case isExpired && !isSold:
      badgeClassName =
        'bg-yellow-1 rounded-3xl py-1 px-2 w-full h-full text-yellow-2';
      badgeText = 'منقضی شد';
      break;
    case !isExpired && !isSold && status === 'pending':
      badgeClassName =
        'bg-pink rounded-3xl py-1 px-2 w-full h-full text-blue-2';
      badgeText = 'در انتظار تأیید';
      break;

    case isSold:
      badgeClassName =
        'bg-white rounded-3xl py-1 px-2 w-full h-full text-gray-8';
      badgeText = 'فروخته شده';
      break;

    case !isExpired && !isSold && status === 'rejected':
      badgeClassName =
        'bg-red-3 rounded-3xl py-1 px-2 w-full h-full text-red-4';
      badgeText = 'تأیید نشده';
      break;

    case !isSold && !isExpired && status === 'published':
      badgeClassName =
        'bg-blue rounded-3xl py-1 px-2 w-full h-full text-purple';
      badgeText = createdDate;
      break;
    default:
      break;
  }
  return <span className={badgeClassName}>{badgeText}</span>;
};

export default BadgeSwitcher;
